import { createFileRoute, Outlet } from "@tanstack/react-router";
import { GrantsExitIntent } from "@/components/grants-exit-intent";
import { ExtensionUpsellModal } from "@/components/extension-upsell-modal";

export const Route = createFileRoute("/grants")({
  component: () => (
    <>
      <Outlet />
      <ExtensionUpsellModal />
      <GrantsExitIntent />
    </>
  ),
});
